/* eslint-disable import/prefer-default-export */
var DEFAULT_SWATCH_COLORS = ['#272727', '#404040', '#777777', '#CCCCCC', '#DDDDDD', '#F7F7F7', '#FFFFFF', '#1E88E5', '#00ACC1', '#43A047', '#C0CA33', '#FB8C00', '#E53935', '#8E24AA', '#3949AB', '#039BE5', '#00897B', '#7CB342', '#FDD835', '#FFB300', '#F4511E', '#5E35B1'];

export { DEFAULT_SWATCH_COLORS };
